<div>
  <gstar-header-modal [id]="modalId" [title]="title" />
  <gstar-body-modal>
    <div>
      <p class="me-5 pe-5">
        {{ description }}
      </p>
      @if (!hasFileSelected()) {
        <button
          class="ap-link bg-transparent ps-0"
          (click)="downloadTemplate()">
          {{ 'portfolio.import.downloadTemplate' | translate }}
        </button>
      }
      <ap-fileupload
        #uploader
        [ngClass]="hasFileSelected() ? 'file-selected' : ''"
        uploadTitle=""
        [config]="fileuploadConfig"
        [fileType]="allowedExtensions"
        [customUploader]="customUploader"
        (onAddFile)="addFile($event)"
        (onDeleteFile)="deleteFile()">
      </ap-fileupload>
    </div>
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId"
    (confirmEvent)="importFile()"
    [isEnabled]="hasFileSelected()"
    [primaryButtonLabel]="'portfolio.import.buttonLabel' | translate" />
</div>
